import { Component, OnInit } from '@angular/core';
import { ItemVenda, Venda, VendaSituacao } from 'src/app/core/models/venda';
import { VendaService } from 'src/app/core/services/venda.service';
import { Vendedor } from 'src/app/core/models/vendedor';
import { VendedorService } from 'src/app/core/services/vendedor.service';

@Component({
  selector: 'app-lista-vendas-por-datas',
  templateUrl: './lista-vendas-por-datas.component.html',
  styleUrls: ['./lista-vendas-por-datas.component.scss']
})
export class ListaVendasPorDatasComponent implements OnInit {
  vendas: Venda[] = [];
  vendasOriginais: Venda[] = []; // Armazena a lista original de vendas
  itemVendas: ItemVenda[] = [];
  vendaSelecionada: Venda | null = null;
  vendedores: Vendedor[] = [];
  selectedVendedorId: number | null = null;
  selectedStatus: string | null = 'VENDA_FECHADA'; // Inicia com 'VENDA_FECHADA' selecionado

// Opções para o Select (baseado no seu novo Enum)
  statusOptions = [
    { label: 'Todas', value: 'TODAS' },
    { label: 'Venda', value: VendaSituacao.venda },
    { label: 'Orçamento', value: VendaSituacao.orcamento },
    { label: 'Pedido', value: VendaSituacao.pedido },
    { label: 'Cancelada', value: VendaSituacao.cancelada },
  ];

  dataInicial: string = '';
  dataFinal: string = '';

  totalValorItens: number = 0;

  constructor(
    private servico: VendaService,
    private vendedorService: VendedorService
  ) {
  }

  ngOnInit() {
    this.setDataInicialEFinal();
    this.carregarVendas(); // Carrega as vendas iniciais
    this.carregarVendedores();
  }

  carregarVendedores(): void {
    this.vendedorService.selecionar().subscribe({
      next: (retorno) => (this.vendedores = retorno),
      error: (err) => {
        console.error('Erro ao carregar vendedores:', err);
        this.vendedores = [];
      },
    });
  }

  setDataInicialEFinal(): void {
    const hoje = new Date();
    this.dataInicial = this.formatarData(hoje);
    this.dataFinal = this.formatarData(hoje);
  }

  formatarData(data: Date): string {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  converterParaFormatoBR(data: string): string {
    const [ano, mes, dia] = data.split('-');
    return `${dia}/${mes}/${ano}`;
  }

  // Carrega as vendas da API e armazena na lista original
  carregarVendas(): void {
    if (this.dataInicial && this.dataFinal) {

      const dataInicialBR = this.converterParaFormatoBR(this.dataInicial);
      const dataFinalBR = this.converterParaFormatoBR(this.dataFinal);

      this.servico.selecionarPorData(dataInicialBR, dataFinalBR).subscribe((retorno) => {
        this.vendasOriginais = retorno;
        this.filtrarVendas(); // Aplica os filtros atuais
      });
    } else {
      alert('Por favor, selecione as duas datas.');
    }
  }

  // Aplica os filtros na lista de vendas original
filtrarVendas(): void {
  let vendasFiltradas = [...this.vendasOriginais];

  // 1. Filtro por Vendedor
  if (this.selectedVendedorId) {
    vendasFiltradas = vendasFiltradas.filter(
      (venda) => venda.vendedor && venda.vendedor.id === this.selectedVendedorId
    );
  }

  // 2. Filtro por Status
  // Só filtra se houver um status selecionado E se não for a opção "Todas"
  if (this.selectedStatus && this.selectedStatus !== 'TODAS') {
    vendasFiltradas = vendasFiltradas.filter(
      (venda) => venda.vendaSituacao === this.selectedStatus
    );
  }

  this.vendas = vendasFiltradas;
  this.calcularTotalItens();
}

  onFiltroChange(): void {
    this.filtrarVendas();
  }

  onDataChange(): void {
    this.carregarVendas();
  }

  selecionarVenda(venda: Venda): void {
    this.vendaSelecionada = venda;
    this.itemVendas = venda.itens;
    console.log(this.vendaSelecionada);
  }

  calcularTotalItens(): void {
    this.totalValorItens = 0;
    this.vendas.forEach(venda => {
      venda.itens.forEach(item => {
        this.totalValorItens += item.valorTotal;
      });
    });
  }

  limparFiltros(): void {
    this.selectedVendedorId = null;
    this.selectedStatus = null;
    this.filtrarVendas();
  }

  // Novo método para obter o label do status
  getStatusLabel(status: string): string {
    const foundStatus = this.statusOptions.find(s => s.value === status);
    return foundStatus ? foundStatus.label : status;
  }
}
